import React, { useState, useRef } from 'react';
import Skills from './Skills';
import ContentCard from './ContentCard';
import About from './About';
import Projects from './Projects';
import Experience from './Experience';
import Education from './Education';
import Resume from './Resume';

export default function Navbar() {
    const[heading, setHeading] = useState('Home');
    const[cont, setContent] = useState(<About/>);
    const menuToggleRef = useRef(null);

    const changeHeadingAndContent = (e) => {
        if(e.target.getAttribute('data-value') === 'home') {
            setHeading('Home');
            setContent(<About/>)
        }
        else if(e.target.getAttribute('data-value') === 'skills'){
            setHeading('');
            setContent(<Skills/>)
        }
        else if(e.target.getAttribute('data-value') === 'projects'){
            setHeading('');
            setContent(<Projects/>)
        }
        else if(e.target.getAttribute('data-value') === 'experience'){
            setHeading('');
            setContent(<Experience/>)
        }
        else if(e.target.getAttribute('data-value') === 'education'){
            setHeading('');
            setContent(<Education/>)
        }
        else if(e.target.getAttribute('data-value') === 'resume'){
            setHeading('');
            setContent(<Resume/>)
        }
        if (menuToggleRef.current) {
            menuToggleRef.current.checked = false; // Close the menu when an item is clicked
        }
    }
    
    return (
      <>
        <nav className='mobile navigation-menu'>
          <nav role="navigation">
              <div id="menuToggle">
                  <input type="checkbox" ref={menuToggleRef} />
                  <span></span>
                  <span></span>
                  <span></span>
                  <ul id="menu">
                    <div className='list'><li onClick={changeHeadingAndContent} data-value='home'>Home</li></div>
                    <div className='list'><li onClick={changeHeadingAndContent} data-value='skills'>Skills</li></div>
                    <div className='list'><li onClick={changeHeadingAndContent} data-value='projects'>Projects</li></div>
                    <div className='list'><li onClick={changeHeadingAndContent} data-value='experience'>Experience</li></div>
                    <div className='list'><li onClick={changeHeadingAndContent} data-value='education'>Education</li></div>
                    <div className='list'><li onClick={changeHeadingAndContent} data-value='resume'>Resume</li></div>
                  </ul>
              </div>
              <span className='mobile-navigation heading'>{heading}</span>
          </nav>
        </nav>
        <ContentCard content={cont}/>
      </>
    )
}